var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndoRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14.851,
    viewBox: "0 0 16 14.851",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_20799",
    "data-name": "\\u7EC4 20799",
    transform: "translate(-19798.999 -1528)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "noun-undo-5094511",
    d: "M243.122,275.291l-.333-.5a.53.53,0,0,0-.883.589l1.149,1.724a.532.532,0,0,0,.4.234h0a.526.526,0,0,0,.334-.088l1.724-1.149a.53.53,0,0,0-.589-.883l-.813.542a6.367,6.367,0,1,1,2.567,6.218.53.53,0,1,0-.62.861,7.424,7.424,0,1,0-2.938-7.548Z",
    transform: "translate(19557.182 1258.616)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-delete-4602521",
    transform: "translate(19804 1531)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_247810",
    "data-name": "\\u8DEF\\u5F84 247810",
    d: "M125.164,34.581a.764.764,0,0,0-.237-.55.826.826,0,0,0-.573-.228h-1.293a1.324,1.324,0,0,0-.474-.792,1.431,1.431,0,0,0-1.786,0,1.324,1.324,0,0,0-.474.792h-1.293a.823.823,0,0,0-.73.341.755.755,0,0,0-.058.779.813.813,0,0,0,.672.437v4.533a.792.792,0,0,0,.246.569.857.857,0,0,0,.591.236h3.877a.857.857,0,0,0,.591-.236.792.792,0,0,0,.246-.569V35.359a.819.819,0,0,0,.5-.264.761.761,0,0,0,.195-.515Zm-3.47-1.446a.949.949,0,0,1,.566.187.888.888,0,0,1,.329.481H120.8a.888.888,0,0,1,.329-.481.949.949,0,0,1,.566-.187Zm2.313,6.758a.356.356,0,0,1-.11.254.385.385,0,0,1-.264.106h-3.877a.385.385,0,0,1-.264-.106.356.356,0,0,1-.11-.254V35.359h4.627Zm.347-4.978h-5.321a.35.35,0,0,1-.3-.167.323.323,0,0,1,0-.334.35.35,0,0,1,.3-.167h5.321a.35.35,0,0,1,.3.167.323.323,0,0,1,0,.334.35.35,0,0,1-.3.167Z",
    transform: "translate(-118.164 -32.698)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_247811",
    "data-name": "\\u8DEF\\u5F84 247811",
    d: "M568.662,509.071a.24.24,0,0,0,.24-.24V505.47a.24.24,0,1,0-.48,0v3.361a.24.24,0,0,0,.24.24Z",
    transform: "translate(-565.132 -502.271)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_247812",
    "data-name": "\\u8DEF\\u5F84 247812",
    d: "M726.552,571.3a.24.24,0,0,0,.24-.24v-2.4a.24.24,0,1,0-.48,0v2.4a.24.24,0,0,0,.24.24Z",
    transform: "translate(-721.869 -564.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_247813",
    "data-name": "\\u8DEF\\u5F84 247813",
    d: "M410.772,571.3a.24.24,0,0,0,.24-.24v-2.4a.24.24,0,0,0-.48,0v2.4a.24.24,0,0,0,.24.24Z",
    transform: "translate(-408.396 -564.799)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoRemove);
export default __webpack_public_path__ + "static/media/undoRemove.2d0a1e1feea6ca5fbed981597cad73f6.svg";
export { ForwardRef as ReactComponent };